import './option.less'

import {OptionModel} from 'models/configuration/OptionModel'
import {ConfigureStepModel} from 'models/registration/steps/ConfigureStepModel'
import React from 'react'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
import {FormField} from 'views/form/form'

const styles = style('option')

export const Option: React.FC<{
	step: ConfigureStepModel
	option: OptionModel
}> = ({step, option}) => {
	const t = useTranslation()
	return (
		<div {...styles}>
			<h3 {...styles('title')}>{option.label}</h3>
			<div {...styles('options')}>
				{option.choices.map(choice => {
					return (
						<>
							<FormField
								type="radio"
								label={choice.label}
								description={choice.description}
								value={choice.key}
								name={option.key}
								required={true}
								disabled={choice.disabled}
							/>
							{option.getChoiceFor(step.registration)?.key === choice.key &&
								choice.shouldIncludeComments && (
									<div>
										<FormField
											component="textarea"
											name={option.key + '_comments'}
											label={t('config.comments')}
											mod="background"
										/>
									</div>
								)}
						</>
					)
				})}
			</div>
		</div>
	)
}
